export interface DanceManagerUserGroupsInterface {
  id?: string;
  name?: string;
  userIds?: string[];
  danceManagerId?: string;
}


